import { render, staticRenderFns } from "./CreateMatchSettingDialog.vue?vue&type=template&id=42381655"
import script from "./CreateMatchSettingDialog.vue?vue&type=script&lang=js"
export * from "./CreateMatchSettingDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports